var noAnim = true; //アニメーションなし
var kvAnim = {
	bgScale:0,
	ease:'easeInOutCubic',
	copy_step:0,
	init:function(){
		var t=this;
		t.bgScale = 1.5;

		$('.product_kv_bg').stop().velocity('stop').velocity({scale:3,opacity:0},1);
		$('.main_sholder').stop().velocity('stop').velocity({opacity:0},1);
		$('.main_ttl').stop().velocity('stop').velocity({opacity:0},1);
		$('.watch_the_video').stop().velocity('stop').velocity({opacity:0},1);
		$('.release_date').stop().velocity('stop').velocity({opacity:0},1);

		// $('.fv_area').stop().velocity('stop').velocity({top:'53%',translateY:'-50%',translateX:'-50%'},{duration:0});
		

		//Indicator
		$('.product_kv').append('<ul id="kv_indi"></ul>');

		$('.kv_scrl_block').each(function(i,elm){
			let dom = '';
			dom += '<li><a href="#kv-block0'+i+'" class="indi_'+i+'" data-num="'+i+'"></a></li>';
			$('#kv_indi').append(dom);

		});


	},
	show:function(){
		var t = this;
		$('.bg_cover').stop().velocity('stop').velocity({opacity:0},{duration:1400,delay:500,easing:'linear'});
		
		setTimeout(function(){
			$('.main_sholder').stop().velocity('stop').velocity({opacity:1},{duration:1500,delay:2000});
			$('.main_ttl').stop().velocity('stop').velocity({opacity:1},{duration:1500,delay:2500});
			$('.watch_the_video').stop().velocity('stop').velocity({opacity:1},{duration:1500,delay:3000});
			$('.release_date').stop().velocity('stop').velocity({opacity:1},{duration:1500,delay:3500});
		},250);
	},
	copyStep:function($block,num){
		
	},
	leave:function(){
		
	}
}
